import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_SSO_CLIENTID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_SSO_TENET_ID}`,
    redirectUri: process.env.REACT_APP_SSO_REDIRECTURI || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_SSO_REDIRECTURI || window.location.origin,
    // redirectUri: window.location.origin,
    // postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",
};

export const msalInstance = new PublicClientApplication(msalConfig);
